import Model from '@models/model';

export const physicalBranchApiUrl = '/api/branches?filter[is_active]=1&filter[is-physical]=1';

export const mapBranchesToSelect = (branches) => branches.map(((branch) => ({ id: branch.id, text: branch.name })));

export default class Branch extends Model {
    resource() {
        return 'branches';
    }

    static getPhysicalBranches() {
        return this.isActive()
            .where('is-physical', true)
            .list()
            .get();
    }

    static async getDeliveryServiceBranches() {
        const response = await this.isActive()
            .where('is-physical', true)
            .list()
            .get();

        return response.filter((branch) => branch.id != 16);
    }

    static async getNextWorkDate() {
        const response = await this.api().get('/api/branches/next-work-date');
        return response.data.next_work_date;
    }
}
